import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Helper/Helper";

// Define Initial State
const initialState = {
  status: "",
  message: "",
  redirectedToHome: null,
  redirectedToLogin: null,
  isLoggedIn: false,
  isInRegistration: false,
};


export const register = createAsyncThunk("register", async (formData) => {
  const response = await axiosInstance.post("user/signup", formData);
  const result = response.data;

  
  return result;
});


export const logIn = createAsyncThunk("login", async (formData) => {
  const response = await axiosInstance.post("user/signin", formData);
  const result = response.data;

  
  return result;
});


export const authenticationSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    
    reset_registration: (state) => {
      state.status = "";
      state.message = "";
      state.redirectedToLogin = null;
    },
    
    reset_login: (state) => {
      state.status = "";
      state.message = "";
      state.redirectedToHome = null;
    },

    handleLogout: (state) => {
      localStorage.removeItem("token"); 
      localStorage.removeItem("firstName"); 
      localStorage.removeItem("lastName"); 
      localStorage.removeItem("Firstname"); 
      localStorage.removeItem("Email"); 
      state.isLoggedIn = false;
      state.isInRegistration = false;
    },
   
    check_token: (state) => {
      const token = localStorage.getItem("token");
      if (token !== null && token !== undefined) {
        state.isLoggedIn = true;
      }
    },
    check_name: (state) => {
      const name = localStorage.getItem("firstName");
      if (name !== null && name !== undefined) {
        state.isInRegistration = true;
      }
    },
  },
  extraReducers: (builder) => {
    
    builder.addCase(register.pending, (state) => {
      state.status = "Loading...";
    });
    builder.addCase(register.fulfilled, (state, { payload }) => {
      state.status = "Success";
      state.message = payload.message;
      localStorage.setItem("firstName", payload.data.first_name);
      localStorage.setItem("lastName", payload.data.last_name);
      state.isInRegistration = true;
      state.redirectedToLogin = "/login";
    });
    builder.addCase(register.rejected, (state, { error }) => {
      state.status = "Rejected";
      state.message = error.message;
    });

   
    builder.addCase(logIn.pending, (state) => {
      state.status = "Loading...";
    });
    builder.addCase(logIn.fulfilled, (state, { payload }) => {
      state.status = "Success";
      state.message = payload.message;
      localStorage.setItem("token", payload.token);
      localStorage.setItem("Firstname", payload.data.first_name);
      localStorage.setItem("Email", payload.data.email);
      state.isLoggedIn = true;
      state.redirectedToHome = "/";
    });
    builder.addCase(logIn.rejected, (state, { error }) => {
      state.status = "Rejected";
      state.message = error.message;
    });
  },
});

export const {
  reset_registration,
  reset_login,
  handleLogout,
  check_token,
  check_name,
} = authenticationSlice.actions;
